export const merge = (target, source, opts) => {
  const isObject = obj => obj && typeof obj === 'object' && !Array.isArray(obj);
  const isConcatArray = opts && opts.concatArray;
  let result = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    for (const [sourceKey, sourceValue] of Object.entries(source)) {
      const targetValue = target[sourceKey];
      if (isConcatArray && Array.isArray(sourceValue) && Array.isArray(targetValue)) {
        result[sourceKey] = targetValue.concat(...sourceValue);
      }
      else if (isObject(sourceValue) && target.hasOwnProperty(sourceKey)) {
        result[sourceKey] = merge(targetValue, sourceValue, opts);
      }
      else {
        Object.assign(result, { [sourceKey]: sourceValue });
      }
    }
  }
  return result;
};

export const deepCopy = (source) => {
  return JSON.parse(JSON.stringify(source));
};

export const getValueIgnoreCase = (source, key) => {
  return source[Object.keys(source).find(k => k.toLowerCase() === key.toLowerCase())];
};

export const jsonTryParse = (str) => {
  let result = null;
  try {
    result = JSON.parse(str);
  } catch {
    return result;
  }
  return result;
};
